import { NODES } from '@te_react/volt-store/lib/constants'
import { isCatchUp } from './isCatchUp';

export const universeIdToFirebaseId = (
    node: string,
    config: { analytics: { firebaseScreen: Record<string, string> } }
): string | undefined => {
    switch (node) {
        case NODES.rootCoach:
            return config.analytics.firebaseScreen.HOME;
        case NODES.rootSearch:
        case NODES.rootContentSearch:
            return config.analytics.firebaseScreen.SEARCH;
        case NODES.rootVod:
            return config.analytics.firebaseScreen.VOD;
        case NODES.rootSport:
            return config.analytics.firebaseScreen.SPORTS;
        case NODES.rootApps:
            return config.analytics.firebaseScreen.APPS;
        case 'root-mytv':
            return config.analytics.firebaseScreen.MYTV;
        case NODES.rootEpg:
            return config.analytics.firebaseScreen.EPG;
        case NODES.rootRecordings:
            return config.analytics.firebaseScreen.DVR;
        case NODES.rootPackages:
            return config.analytics.firebaseScreen.PACKAGES;
        default:
            return undefined;
    }
}

export function unifyAppName(inputAppName: any): string {
    if (typeof inputAppName === 'string') {
        const appName = (inputAppName || '').toLowerCase().trim()
        if (appName === 'shahid') {
            return 'Shahid'
        } else if (appName === 'starzplay') {
            return 'Starzplay'
        } else if (appName === 'youtube') {
            return 'YouTube'
        } else if (appName.includes('osn')) {
            return 'OSN+'
        }
    }

    return inputAppName // Fallback for unrecognized app names
}

export function getAfterProtocol(url: string) {
    if (url.includes('shahid')) {
        return 'Shahid'
    } else if (url.includes('starzplay')) {
        return 'Starzplay'
    } else if (url.includes('youtube')) {
        return 'Youtube' // Return 'youtube' if the URL contains 'youtube'
    } else if (url.includes('osn')) {
        return 'OSN+'
    }
}

export function getContentType(program: any, channel: any){
    if (program?.isLive?.() || program?.isChannel?.()) {
        if (program?.isFutureLive?.()) return 'future_program';
        if (!program?.isLiveNow?.() && isCatchUp(program?.startTime, channel?.rollingBufferDuration)) return 'catchup'
        return 'live'
    }

    if (program?.isDvr?.()) return 'dvr';
    if (program?.isVod?.()) return 'vod';
    if (program?.isSubscription?.()) return 'subscription';
    return 'unknown'
}

export const getAppName = (myTile: any) => {
    let appName: string;
    if (!`${myTile.id}`.match(/^\d/) && `${myTile.id}`?.split('_')?.length > 1) {
        const arr = `${myTile.id}`?.split('_') ?? [];
        appName = unifyAppName(arr?.length > 0 ? arr[0] : '');
    } else {
        const contentNameRaw = myTile?.param && myTile?.param !== ''
            ? getAfterProtocol(myTile?.param)
            : myTile?.title || myTile?.appName;

        appName = unifyAppName(contentNameRaw) || myTile?.title || myTile?.appName;
    }
    return appName;
}

export const getFirebaseTitle = (title: string, serieTitle: string) => {
    return serieTitle && title ? `${serieTitle} - ${title}` : title;
}
